import { useLatestPayPointTransaction } from "Api/Queries/Transactions/useLatestPayPointTransaction";
import { IdlePaypointInfo } from "Components/Paypoints/IdlePaypoint/IdlePaypointInfo";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { Navigate } from "Navigation/Navigate";
import { Resources, useResource } from "Translations/Resources";
import { getAppUrl } from "Utils/UrlUtils";
import { useParams } from "react-router-dom";

export const LatestPayPointTransaction = () => {
  const { id } = useParams();
  const { t } = useResource();
  const { data, isFetching } = useLatestPayPointTransaction(id);

  // Never redirect on a stale answer — wait for the in-flight (re)fetch so the target is the
  // transaction that is open on the pay point right now, not the one from the previous scan.
  if (isFetching) {
    return <CenteredCircularProgress />;
  }

  if (!id) {
    return <ErrorText>{t(Resources.Error.InvalidPaypointId)}</ErrorText>;
  }

  if (data) {
    const appUrl = getAppUrl();
    const transactionPublicID = data.publicID;

    return (
      <Navigate
        to={`${appUrl("customer-payment-pay")}/${transactionPublicID}`}
      />
    );
  }

  return <IdlePaypointInfo publicID={id} />;
};

export default LatestPayPointTransaction;
